import {EnvironmentInterface} from '../app/_interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  appVersion: 'NL 0.05.02',
  language: "nl",
  dbLanguage: "nl",
  apiConfig: {
    createSupportAccessCode: "https://europe-west1-training-ehr-nl.cloudfunctions.net/createSupportAccessCode",
    requestVerificationCode: 'https://requestverificationcode-b7i6xyv7va-ew.a.run.app',
    verifyCodeForLocation: 'https://verifycodeforlocation-b7i6xyv7va-ew.a.run.app',
    requestResetPasswordEmail: 'https://requestresetpasswordemail-b7i6xyv7va-ew.a.run.app',
    getLocationPresenceForDate: 'https://getlocationpresencefordate-b7i6xyv7va-ew.a.run.app',
    getLocationSchedule: 'https://getlocationschedule-b7i6xyv7va-ew.a.run.app',
    locationClockIn: 'https://locationclockin-b7i6xyv7va-ew.a.run.app',
    locationClockOut: 'https://locationclockout-b7i6xyv7va-ew.a.run.app',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCGFkaaGXsBpW_4j89IN44OxTI1QiVxgzg',
    authDomain: "training-ehr-nl.firebaseapp.com",
    projectId: "training-ehr-nl",
    storageBucket: "training-ehr-nl.firebasestorage.app",
    messagingSenderId: "341455147287",
    appId: '1:341455147287:web:bfcc832f173d3b397f2752',
    measurementId: 'G-2SED4PGGTP'
  }
};

